import UpgradePayment from "./Payment";

const upgradeComponents = {
  UpgradePayment
};

export default upgradeComponents